import { render, staticRenderFns } from "./imageMove.vue?vue&type=template&id=6044d869&scoped=true&"
import script from "./imageMove.vue?vue&type=script&lang=js&"
export * from "./imageMove.vue?vue&type=script&lang=js&"
import style0 from "./imageMove.vue?vue&type=style&index=0&id=6044d869&prod&scoped=true&lang=scss&"
import style1 from "./imageMove.vue?vue&type=style&index=1&id=6044d869&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6044d869",
  null
  
)

export default component.exports